module.exports = __webpack_public_path__ + "static/media/Yoyo_6932.01bb1229.jpg";